import Fonts from './Fonts';

export * from './Colors';
export * from './Fonts';

export default () => <Fonts />;
